import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
import _ from 'lodash';
import { IsEmpty } from '../../common/checks';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker, Day
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  pickerView: {
    width: '100%',
    maxWidth: '100%',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 50,
  },
});

class DatePicker extends Component {
    constructor(props) {
      super(props);
      this.state = {
        exceptionDatesToBlock: [],
        date: '',
      }
    } 

    componentDidMount() {
      if ( !IsEmpty(this.props.exception) ) {
        const exceptionDates = _.filter(this.props.exception, e => e.date !== moment(new Date()).format("DD-MM-YYYY") );
        this.setState({ exceptionDatesToBlock: exceptionDates });
      }
    }

    handleAutoAddExc = (date) => {
      this.setState( { date: moment(date).format("DD-MM-YYYY") }, function() {
        if ( moment( date ).format("DD-MM-YYYY") === this.state.date ){
          this.props.triggerAddExc( moment( date ).format("DD-MM-YYYY") )
        }
      })
    }

    render() {
        const newCurrentDate = this.state.date;
        return (
        <>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              shouldDisableDate={(date) => {
                const datesToBlock = this.state.exceptionDatesToBlock;
                if(datesToBlock.length > 0){
                  const storeDates = [];
                  for( let e = 0; e < datesToBlock.length; e+=1 ){
                    storeDates.push( moment(datesToBlock[e].date, 'DD-MM-YYYYTHH:mm:ssZ').toDate() )
                    
                    if( e === datesToBlock.length-1 ){ 
                      for( let x = 0; x < storeDates.length; x+=1 ){
                        if( 
                            date.getDate() === moment( storeDates[x], 'DD-MM-YYYYTHH:mm:ssZ').toDate().getDate() &&
                            date.getMonth() === moment( storeDates[x], 'DD-MM-YYYYTHH:mm:ssZ').toDate().getMonth() &&
                            date.getFullYear() === moment( storeDates[x], 'DD-MM-YYYYTHH:mm:ssZ').toDate().getFullYear()
                          ) {
                          return true
                        }
                      }
                    }
                  }
                }
              }}
              //disableToolbar
              animateYearScrolling={false}
              allowKeyboardControl={false} 
              variant="static"
              format="dd/MM/yyyy"
              margin="normal"
              className="material-date-picker"
              label="Select date"
              onChange={(data) => this.handleAutoAddExc(data)}
              onKeyDown={e => e.preventDefault()}
              autoOk={true}
              width="100%"
            />
          </MuiPickersUtilsProvider>
        </>
        );
    }
}

export default withStyles(styles, { withTheme: true })(DatePicker);